import { render, staticRenderFns } from "./DetailV2.vue?vue&type=template&id=998a9eb6&scoped=true&"
import script from "./DetailV2.vue?vue&type=script&lang=js&"
export * from "./DetailV2.vue?vue&type=script&lang=js&"
import style0 from "./DetailV2.vue?vue&type=style&index=0&id=998a9eb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "998a9eb6",
  null
  
)

export default component.exports